import Vue from 'vue'
import VueRouter from 'vue-router'
import Autocom from '../components/Vehiculo.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Vehiculo',
    component: Autocom
  },
  {
    path: '/Vendedor',
    name: 'Vendedor',
    component: () => import(/* webpackChunkName: "Vendedor" */ '../components/Vendedor.vue')
  },
  {
    path: '/Oferta',
    name: 'Oferta',
    component: () => import(/* webpackChunkName: "Oferta" */ '../components/Oferta.vue')
  },
  {
    path: '/noOferta',
    name: 'noOferta',
    component: () => import(/* webpackChunkName: "noOferta" */ '../components/noOferta.vue')
  },
  {
    path: '/Inspeccion',
    name: 'Inspeccion',
    component: () => import(/* webpackChunkName: "Inspeccion" */ '../components/Inspeccion.vue')
  },
  {
    path: '/Evaluacion',
    name: 'Evaluacion',
    component: () => import(/* webpackChunkName: "Evaluacion" */ '../components/Evaluacion.vue')
  },
  {
    path: '/Reagendamiento',
    name: 'Reagendamiento',
    component: () => import(/* webpackChunkName: "Reagendamiento" */ '../components/Reagendamiento.vue')
  },
  {
    path: '/Reagendar',
    name: 'Reagendar',
    component: () => import(/* webpackChunkName: "Reagendar" */ '../components/Reagendar.vue')
  },
  {
    path: '/Valoracion',
    name: 'Valoracion',
    component: () => import(/* webpackChunkName: "Valoracion" */ '../components/Valoracion.vue')
  },
  {
    path: '/Documentos',
    name: 'Documentos',
    component: () => import(/* webpackChunkName: "Documentos" */ '../components/Documentos.vue')
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return new Promise((resolve) => {
      resolve({ left: 0, top: 0 })
    })
  },
  routes
});

export default router
